import {imageBaseUrl} from "@maya/components";

interface PartnerOffering {
  name: string;
  companyName?: string;
  offers?: string[];
  logo: string;
  message?: string;
  colors?: {
    green: string;
    blue: string;
    white: string;
  };
  optionCardIcon?: string;
  supportEmail?: string;
  loaderImage?: string;
}

export const partnerOfferings : Record<string, PartnerOffering>= {
  Fino: {
    name: "Fino Payments Bank Limited",
    companyName: "Fino",
    offers: [
      "Credit upto Rs. 2 lacs",
      "2.5% flat interest per month",
      "Anytime withdrawal",
      "1 day repayment",
      "Money in Fino Account",
    ],
    logo: `${imageBaseUrl}/img/FinoPaymentsBankNewLogoIndingo.jpg`,
    message:
      "You have successfully submitted your consent to avail credit line service of Ekagrata Finance via MyShubhLife. MyShubhLife team will reach you shortly.",
  },
  scadvantageclub: {
    name: "Advantage Club Private Limited",
    companyName: "Advantage Club",
    offers: [
      "Credit up to Rs. 2 lacs",
      "2.5% flat interest per month",
      "1-day disbursement",
      "Money into your bank account",
      "No physical documentation and verification",
    ],
    logo: `${imageBaseUrl}/img/logo/advantageClubLogo.png`,
  },
  SCEASYPAY: {
    name: "Easy Pay Private Limited",
    logo: `${imageBaseUrl}/img/logo/easypay-logo.png`,
    colors: {
      green: "#35bb8d",
      blue: "#624fa1",
      white: "#ffffff",
    },
    optionCardIcon: `${imageBaseUrl}/img/consent/option_card_circle_easypay.svg`,
    supportEmail: "customercare@easypay.in",
    loaderImage: `${imageBaseUrl}/img/consent/processing-easypay.png`,
  },
  scspicemoney: {
    name: "Spice Money Limited",
    offers: [
      "Credit upto Rs. 2 lacs",
      "2.5% flat interest per month",
      "Anytime withdrawal",
      "1 day repayment",
      "Money in Bank Account",
    ],
    logo: `${imageBaseUrl}/img/logo/spicemoney-logo.png`,
  },
  scairteldis: {
    name: "Airtel Payments Bank Limited",
    offers: [
      "Credit limit upto Rs. 50 lacs",
      "2.5% flat interest per month",
      "Anytime withdrawal",
      "1 day repayment",
      "Money in Bank Account",
    ],
    logo: `${imageBaseUrl}/img/logo/airtelPaymentsBank-logo.png`,
  },
  scairtelrt: {
    name: "Airtel Payments Bank Limited",
    offers: [
      "Credit limit upto Rs. 2 lacs",
      "2.5% flat interest per month",
      "Anytime withdrawal",
      "1 day repayment",
      "Money in Bank Account",
    ],
    logo: `${imageBaseUrl}/img/logo/airtelPaymentsBank-logo.png`,
  },
  scairteltl: {
    name: "Airtel Payments Bank Limited",
    offers: [
      "Term loan upto Rs. 10 lacs",
      "2.5% flat interest per month",
      "Money in Bank Account",
    ],
    logo: `${imageBaseUrl}/img/logo/airtelPaymentsBank-logo.png`,
  },
  scairteltlrt: {
    name: "Airtel Payments Bank Limited",
    offers: [
      "Term loan upto Rs. 2 lacs",
      "2.5% flat interest per month",
      "Money in Bank Account",
    ],
    logo: `${imageBaseUrl}/img/logo/airtelPaymentsBank-logo.png`,
  },
  SCMEESHO: {
    name: "Meesho",
    offers: [
      "Term loan upto Rs. 10 lacs",
      "Tenure 3, 6, 9 & 12 months",
      "Money in Bank Account",
    ],
    logo: `${imageBaseUrl}/img/logo/meesho-logo.svg`,
  },
  scflipkart: {
        name: "Flipkart",
        offers: [
            "Instant Loan Approvals",
            "With Flexible Loan Tenures 3, 6, 9, 12, 15, 18, 21 & 24 months",
            "Paperless Process",
            "Money in Bank Account",
        ],
        logo: `${imageBaseUrl}/img/logo/FK-logo.svg`,
    }
};

export const testimonialData = [
  {
    name: "Vasim Pathan",
    location: "Ahmedabad",
    comment:
      "\"I am grateful to MyShubhLife who understands my condition and helped me see out crunch" +
      "time and it was quick approval and disbursement. I would be happy to endorse this" +
      "brand to others and spread words for them.\"",
    rating: 5,
    imageUrl:
      "https://www.myshubhlife.com/img/testimonials/testimonial_vasim_pathan.jpg",
  },
  {
    name: "Muralidhara",
    location: "Bengaluru",
    comment:
      "\"Before taking a loan from MyShubhLife I was facing financial problems. Now my problems" +
      "are solved because of MyShubhLife. Thank you MyShubhLife for being my financial partner in time of need.\"",
    rating: 5,
    imageUrl:
      "https://www.myshubhlife.com/img/testimonials/testimonial_muralidhara.jpg",
  },
  {
    name: "Suraj M A",
    location: "Bengaluru",
    comment:
      "\"I received very good service from MyShubhLife for my personal loan application. The staff at MyShubhLife" +
      "is extremely helpful. Thank you so much MyShubhLife team for the quick and hassle-free procedure.\"",
    rating: 5,
    imageUrl:
      "https://www.myshubhlife.com/img/testimonials/testimonial_suraj_ma.jpg",
  },
];

export const loanBreakoutDetails = [
  {
    title: "Loan Amount",
    value: "₹1,00,000",
  },
  {
    title: "Duration",
    value: "1 year",
  },
  {
    title: "Interest Rate",
    value: "₹26%",
  },
  {
    title: "EMI",
    value: "₹9,553",
  },
  {
    title: "Total Interest",
    value: "₹14,636",
  },
  {
    title: "Processing Fee (@2%)",
    value: "₹2,000 + GST",
  },
  {
    title: "Total Cost",
    value: "₹16,996",
  },
  {
    title: "APR",
    value: "29.9%.",
  },
];
